const PROTECTED_DELETE_PATTERN =
  /protected foreign keys|Checkpoint\.responsibility|related checkpoints or inspections/i;

const MESSAGES = {
  responsibility:
    "This responsibility cannot be deleted because it has related checkpoints or inspections.",
  role: "This role cannot be deleted because it is still referenced by other records.",
  item: "This record cannot be deleted because it is still referenced by other records.",
};

function extractApiErrorText(error) {
  const data = error?.response?.data;
  if (typeof data === "string") return data;
  if (Array.isArray(data) && data.length) return String(data[0]);
  if (data && typeof data === "object") {
    const value = data.detail ?? data.error ?? data.message;
    if (Array.isArray(value) && value.length) return String(value[0]);
    if (value != null) return String(value);
  }
  return "";
}

export function getDeleteErrorMessage(error, { entity = "item" } = {}) {
  const text = extractApiErrorText(error);
  if (PROTECTED_DELETE_PATTERN.test(text)) {
    return MESSAGES[entity] || MESSAGES.item;
  }
  if (text && !/internal server error/i.test(text)) {
    return text;
  }
  return `Unable to delete this ${entity}. Please try again.`;
}
